import { useState, useEffect, useRef } from 'react';
import ReactPlayer from 'react-player';
import { CloudfrontVideoFormat } from '../videos/CloudfrontVideoFormat';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';

/**
 * The surprise video is shown after the user completes all days of a module.
 * It combines the user&apos;s recorded singing with the user&apos;s photos and their
 * influencer&apos;s photos to create a new photo montage.
 * @param {*} props
 * @returns
 */
export default function Surprise(props) {
  // Initialize variables to be used later
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const audioRef = useRef();
  const [, forceUpdate] = useState();
  const [idx, setIdx] = useState(0);
  const [displayIntroVideo, setDisplayIntroVideo] = useState(
    !!props.introVideo
  );
  const [displaySurpriseVideo, setDisplaySurpriseVideo] = useState(
    !props.introVideo
  );
  const [displaySurpriseImage, setDisplaySurpriseImage] = useState(false);
  const [Exit] = useState(login.cloudFront + 'images/Images/close.png' + login.cookie);

  // Video/Image player CSS code
  const videoPlayer = {
    position: 'absolute',
    top: '5vh',
    left: '50%',
    marginLeft: '-25vw',
  };
  const imagePlayer = {
    position: 'absolute',
    top: '5vh',
    left: '50%',
    marginLeft: '-195px',
    height: '550px',
    width: '391px',
  };

  // Set a timer for ms miliseconds
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    if (props.slides[idx].video.includes('.jpg')) {
      sleep(2000).then(() => {
        setIdx((i) => i + 1);
        setDisplaySurpriseVideo(true);
        setDisplaySurpriseImage(false);
        forceUpdate();
      });
    }
  }, [displaySurpriseImage, idx, props.slides]);

  // The HTML code to display the video player and run the slides.
  return (
    <>
      {!displayIntroVideo && (
        <audio autoPlay ref={audioRef} onPlaying={()=>{audioRef.current.volume = 0.4}}> 
          <source src={props.music}></source>
        </audio>
      )}
      <div
        className='learnBody'
        id='slideshow-wrapper'
        style={{ backgroundImage: `url(${props.background})` }}
      >
        <img
          className='back-btn-ftb'
          alt=''
          src={Exit}
          onClick={() => {
            props.setDisplaySurprise(false);
          }}
        ></img>
        {displayIntroVideo && (
          <CloudfrontVideoFormat
            source={props.introVideo}
            back={props.back}
            background={props.background}
            close={props.setDisplaySurprise}
            ended={() => {
              setDisplaySurpriseVideo(true);
              setDisplayIntroVideo(false);
            }}
          />
        )}
        {displaySurpriseVideo && (
          <center>
            <ReactPlayer
              onError = {() => {
                if (idx === props.slides.length - 1) {
                  props.setDisplaySurprise(false);
                  if(props.step_completed){
                    dispatch({ type: props.step_completed, payload: 'surprise' });
                  }
                } else {
                  setIdx(idx + 1);
                  if (props.slides[idx + 1].video.includes('.mp4')) {
                    setDisplaySurpriseVideo(true);
                    setDisplaySurpriseImage(false);
                  } else {
                    setDisplaySurpriseImage(true);
                    setDisplaySurpriseVideo(false);
                  }
                  forceUpdate();
                }
              }}
              onEnded={() => {
                if (idx === props.slides.length - 1) {
                  props.setDisplaySurprise(false);
                  if(props.step_completed){
                    dispatch({ type: props.step_completed, payload: 'surprise' });
                  }
                } else {
                  setIdx(idx + 1);
                  if (props.slides[idx + 1].video.includes('.mp4')) {
                    setDisplaySurpriseVideo(true);
                    setDisplaySurpriseImage(false);
                  } else {
                    setDisplaySurpriseImage(true);
                    setDisplaySurpriseVideo(false);
                  }
                  forceUpdate();
                }
              }}
              height='90vh'
              width='50vw'
              style={videoPlayer}
              playing
              url={props.slides[idx].video}
              playsinline={true}
            />
          </center>
        )}
        {displaySurpriseImage && (
          <img alt='' style={imagePlayer} src={props.slides[idx].video} />
        )}
      </div>
    </>
  );
}

/**
 * Run a slideshow of images that will slowly pan up and down, synced to the chosen audio.
 * @param {*} props
 * @returns The HTML code for a slideshow.
 */
export function SlideShow(props) {
  // Initialize variables to be used later
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [, forceUpdate] = useState();
  const [idx, setIdx] = useState(0);
  const [displaySurpriseImage, setDisplaySurpriseImage] = useState(false);
  const [Exit] = useState(login.cloudFront + 'images/Images/close.png' + login.cookie);
  
  useEffect(() => {
    if (props.slides[idx].video.includes('.jpg')) {
      sleep(2000).then(() => {
        setIdx((i) => i + 1);
        setDisplaySurpriseImage(false);
        forceUpdate();
      });
    }
  }, [displaySurpriseImage, idx, props.slides]);

  // Set a timer for ms miliseconds
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // The HTML code to show and display the slideshow. Note that this is only a wrapper for the slideshow,
  // and the bulk of the actual code can be found elsewhere.
  return (
    <>
      {!displaySurpriseImage && (
        <div id='slideshow-wrapper' style={{ width: '100%' }}>
          <img
            className='back-btn-ftb'
            src={Exit}
            alt=''
            onClick={() => {
              props.setDisplaySurprise(false);
            }}
          ></img>
          <ReactPlayer
            onEnded={() => {
              if (idx === props.slides.length - 1) {
                props.setOpenVideo(false);
              } else {
                setIdx(idx + 1);
                if (props.slides[idx + 1].video.includes('.mp4')) {
                  setDisplaySurpriseImage(false);
                } else {
                  setDisplaySurpriseImage(true);
                }
                forceUpdate();
              }
            }}
            height={800}
            width={600}
            playing
            url={props.slides[idx].video}
            playsinline={true}
          />
        </div>
      )}
      {displaySurpriseImage && <img alt='' src={props.slides[idx].video} />}
    </>
  );
}
